import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IFaceImage } from '@bca-user-data/models/face-image';

@Component({
  selector: 'bca-choose-image',
  templateUrl: 'choose-image.component.html',
  styleUrls: ['choose-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChooseImageComponent {
  @Input()
  selectedFaceImage: IFaceImage;
  @Input()
  imageRequiredError: boolean;

  @Output()
  openDialog = new EventEmitter<void>();
  @Output()
  delete = new EventEmitter<void>();
}
